import { render, staticRenderFns } from "./AccountFooter.vue?vue&type=template&id=a49ac51a&"
import script from "./AccountFooter.vue?vue&type=script&lang=js&"
export * from "./AccountFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports